import React, { useEffect, useState } from 'react'
import { Table, Badge, Form, Card } from 'react-bootstrap'
import { useTheme } from '../../hooks/useTheme'
import capitalizeText from '../../utils/capitalizeText'

export const EqFinalizadosTotal = ({ot}) => {
    const [query, setQuery]=useState("")
    const { size } = useTheme()
    const screenWidth = size?.width || window.innerWidth
    const isMobile = screenWidth < 768
    const isTablet = screenWidth >= 768 && screenWidth < 992
    
    console.log(ot)
    const [equiposOtIni, setEquiposOtIni]=useState(ot.equipos)

    useEffect( ()=>{
        const filter=ot.equipos.filter(item=> item.estado=='Finalizado' ||  item.estado=='Cancelado' ||  item.estado=='Aprobado' ||  item.estado=='Entregado')
        setEquiposOtIni(filter)
    },[])
    
    //Filtro de busqueda
    const equiposOt = !query ? equiposOtIni : equiposOtIni.filter((eq) => {
      const q = query.toLowerCase();
      const s = eq?.snapshot || {};
      return (
        s.item?.toLowerCase().includes(q) ||
        s.marca?.toLowerCase().includes(q) ||
        s.modelo?.toLowerCase().includes(q) ||
        s.serial?.toLowerCase().includes(q) ||
        s.inventario?.toLowerCase().includes(q) ||
        s.ubicacion?.toLowerCase().includes(q) ||
        s.sede?.toLowerCase().includes(q) ||
        eq?.consecutivo?.toLowerCase().includes(q) ||
        eq?.responsable?.nombre?.toLowerCase().includes(q) ||
        eq?.responsable?.apellido?.toLowerCase().includes(q)
      );
    });
      
    // Función para obtener el color del badge según el estado
    const getBadgeVariant = (estado) => {
        switch(estado) {
            case 'Finalizado': return 'success';
            case 'Aprobado': return 'primary';
            case 'Entregado': return 'info';
            case 'Cancelado': return 'danger';
            default: return 'secondary';
        }
    }
    
    // Formatear fecha
    const formatFecha = (fecha) => {
        if (!fecha) return '-';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
    
    // Obtener la fecha correcta según el estado
    const getFechaByEstado = (eq) => {
        switch(eq?.estado) {
            case 'Cancelado': return eq?.fechaCalibracion;
            case 'Pendiente': return eq?.fechaPendiente;
            case 'Finalizado': return eq?.fechaProcesado;
            case 'Aprobado': return eq?.fechaAprobado;
            case 'Entregado': return eq?.fechaEntregado;
            default: return eq?.fechaProcesado;
        }
    }

  return (
    <div>
    {equiposOtIni.length>0? (
      <>
        <Form.Control
          type="text"
          placeholder={isMobile ? "🔍 Buscar..." : "🔍 Buscar por item, marca, modelo, serie, inventario..."}
          className="mb-3"
          onChange={(e)=> setQuery(e.target.value)}
        />
        
        {/* Vista móvil - Cards */}
        {isMobile ? (
          <div className="d-flex flex-column gap-2">
            {equiposOt && equiposOt?.map((eq, index) => (
              <Card key={eq.id || eq._id || index} className="shadow-sm w-100">
                <Card.Body className="p-3">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="flex-grow-1">
                      <div className="text-muted small">#{index + 1}</div>
                      <strong className="d-block">{eq?.snapshot?.item}</strong>
                      <div className="text-muted small mt-1">
                        {eq?.snapshot?.marca} {eq?.snapshot?.modelo && `- ${eq.snapshot?.serial}`}
                      </div>
                    </div>
                    <Badge bg={getBadgeVariant(eq?.estado)}>
                      {eq?.estado}
                    </Badge>
                  </div>
                  
                  <div className="border-top pt-2 mt-2">
                    <div className="row g-2 small">
                      <div className="col-6">
                        <div className="text-muted">Serie:</div>
                        <code className="text-primary">{eq?.snapshot?.serial || '-'}</code>
                      </div>
                      <div className="col-6">
                        <div className="text-muted">Inventario:</div>
                        <code className="text-secondary">{eq?.snapshot?.inventario || '-'}</code>
                      </div>
                      <div className="col-6">
                        <div className="text-muted">Sede:</div>
                        <div>{capitalizeText(eq?.snapshot?.sede || '-')}</div>
                      </div>
                      <div className="col-6">
                        <div className="text-muted">Ubicación:</div>
                        <div>{capitalizeText(eq?.snapshot?.ubicacion || '-')}</div>
                      </div>
                      <div className="col-6">
                        <div className="text-muted">Consecutivo:</div>
                        <Badge bg="dark">{eq?.consecutivo || '-'}</Badge>
                      </div>
                      <div className="col-12 mt-2">
                        <div className="text-muted">Responsable:</div>
                        <strong className="d-block">
                          {eq?.responsable?.nombre + ' ' + eq?.responsable?.apellido || 'Sin asignar'}
                        </strong>
                        <small className="text-muted">
                          {formatFecha(getFechaByEstado(eq))}
                        </small>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            ))}
          </div>
        ) : (
          /* Vista tablet/desktop - Tabla */
          <div className="table-responsive">
            <Table hover bordered striped className="align-middle mb-0">
              <thead className="table-info">
                <tr>
                  <th style={{ width: '50px' }} className="text-center">#</th>
                  <th style={{ minWidth: '150px' }}>Item</th>
                  <th style={{ minWidth: '100px' }}>Marca</th>
                  <th style={{ minWidth: '100px' }}>Modelo</th>
                  <th style={{ minWidth: '100px' }}>Serie</th>
                  {!isTablet && <th style={{ minWidth: '80px' }}>Inventario</th>}
                  <th style={{ minWidth: '120px' }}>Ubicación</th>
                  <th style={{ minWidth: '140px' }}>
                    Responsable
                    <br />
                    <small className="text-muted">Fecha</small>
                  </th>
                  <th style={{ width: '80px' }} className="text-center">Consec.</th>
                  <th style={{ width: '120px' }} className="text-center">Estado</th>
                </tr>
              </thead>
              <tbody>
                {equiposOt && equiposOt?.map((eq, index) => (
                  <tr key={eq.id || eq._id || index}>
                    <td className="text-center text-muted fw-bold">{index + 1}</td>
                    <td>
                      <strong>{eq?.snapshot?.item}</strong>
                    </td>
                    <td>{eq?.snapshot?.marca || '-'}</td>
                    <td>{eq?.snapshot?.modelo || '-'}</td>
                    <td>
                      <code className="text-primary">{eq?.snapshot?.serial || '-'}</code>
                    </td>
                    {!isTablet && (
                      <td>
                        <code className="text-secondary">{eq?.snapshot?.inventario || '-'}</code>
                      </td>
                    )}
                    <td>
                      <strong>{capitalizeText(eq?.snapshot?.sede || '-')}</strong>
                      <br />
                      <small>{capitalizeText(eq?.snapshot?.ubicacion || '-')}</small>
                    </td>
                    <td>
                      <div>
                        <strong>{eq?.responsable?.nombre + ' ' + eq?.responsable?.apellido || 'Sin asignar'}</strong>
                        <br />
                        <small className="text-muted">
                          {formatFecha(getFechaByEstado(eq))}
                        </small>
                      </div>
                    </td>
        
                    <td className="text-center">
                      <Badge bg="dark">{eq?.consecutivo || '-'}</Badge>
                    </td>
                    <td className="text-center">
                      <Badge bg={getBadgeVariant(eq?.estado)} className="w-100">
                        {eq?.estado}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        
        <div className="mt-3 text-muted">
          <small>
            <i className="bi bi-info-circle me-1"></i>
            Mostrando {equiposOt.length} de {equiposOtIni.length} equipos finalizados
          </small>
        </div>
      </>
    ) : (
      <div className="alert alert-warning text-center">
        <i className="bi bi-inbox me-2" style={{ fontSize: '1.5rem' }}></i>
        <h5 className="mb-0">No hay equipos finalizados</h5>
      </div>
    )}
    </div>
  )
}
